import { useState, useEffect } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";

import http from "../../api/server";

import passlogo from "../../assets/img/pass.png";
import emaillogo from "../../assets/img/email.png";

const ChangePassword = (props) => {
  const { onCancel, onFailure, onSuccess } = props;
  const { userObj } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("confirm_email"); //change_password, enter_otp
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [counter, setCounter] = useState(30);
  const inputRefs = useRef([]);

  const defaultOTPObj = {
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: "",
  };
  const [otpValues, setOtpValues] = useState(defaultOTPObj);

  const [validate, setValidate] = useState({
    hasLow: false,
    hasCap: false,
    hasNumber: false,
    has8digit: false,
  });
  const strengthNew = Object.values(validate).reduce((a, item) => a + item, 0);
  const validatePassword = (password) => {
    if (password.match(/\d+/g)) {
      setValidate((o) => ({ ...o, hasNumber: true }));
    } else {
      setValidate((o) => ({ ...o, hasNumber: false }));
    }

    if (password.match(/[A-Z]+/g)) {
      setValidate((o) => ({ ...o, hasCap: true }));
    } else {
      setValidate((o) => ({ ...o, hasCap: false }));
    }

    if (password.match(/[a-z]+/g)) {
      setValidate((o) => ({ ...o, hasLow: true }));
    } else {
      setValidate((o) => ({ ...o, hasLow: false }));
    }

    if (password.length > 7) {
      setValidate((o) => ({ ...o, has8digit: true }));
    } else {
      setValidate((o) => ({ ...o, has8digit: false }));
    }
  };
  const feedback = {
    1: "Password is too weak!",
    2: "It's still weak! ",
    3: "You almost there!",
    4: "Great!! now your password is strong",
  }[strengthNew];

  const strongText = "Great!! now your password is strong";

  const resetScreenShowPass = () => {
    setShowPassword((prev) => !prev);
  };

  const confirmShowPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handlePassword = (value) => {
    setLoginError("");
    setPassword(value);
    validatePassword(value);
  };

  const [enableCountniue, setEnableCountniue] = useState(true);

  useEffect(() => {
    if (!password && !confirmPassword) return;
    if (
      password.length > 7 &&
      confirmPassword.length > 7 &&
      password.length === confirmPassword.length &&
      password === confirmPassword &&
      feedback === strongText
    ) {
      setEnableCountniue(false);
    } else {
      setEnableCountniue(true);
    }
  }, [password, confirmPassword, feedback]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoginError("");
    if (password.length < 8) {
      setLoginError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setLoginError("Passwords do not match.");
      return;
    }
    const response = await resetPasswordAPI(userObj?.userEmail, password);
    if (response.status !== 400) {
      //resetValue();
      setStep("enter otp");
    } else {
      setLoginError(response?.response?.data?.message);
      //setConfirmPassword("");
      //setPassword("");
      // setStep("login");
    }
    setLoading(false);
  };

  const resetPasswordAPI = async (email, password) => {
    try {
      const response = await http.post("/api/Auth/reset-password", {
        email,
        password,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

  const setOTPValue = (value, digitKey, index) => {
    setOtpValues((prevOtpValues) => ({
      ...prevOtpValues,
      [digitKey]: value.substring(value.length - 1), // Take only the last character entered
    }));
    // Auto-focus the next input field if a digit is entered and it's not the last field
    if (value.length === 1 && index !== 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleResend = async () => {
    // Trigger resend OTP logic here
    console.log("Resending OTP...");
    setCounter(30);
    setIsResendDisabled(true);
    const response = await resetPasswordAPI(userObj?.userEmail, password);
    if (response.status !== 400) {
      setStep("enter otp");
    } else {
      setLoginError(response?.response?.data?.message);
      setStep("confirm_email");
    }
    setOtpValues(defaultOTPObj);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && e.target.value === "") {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (pastedData.length === 6 && /^\d+$/.test(pastedData)) {
      const optArray = pastedData.split("");

      const defaultOTPObj = {
        digit1: optArray[0],
        digit2: optArray[1],
        digit3: optArray[2],
        digit4: optArray[3],
        digit5: optArray[4],
        digit6: optArray[5],
      };

      setOtpValues(defaultOTPObj);
      // Optionally focus the last input after pasting
      inputRefs.current[5]?.focus();
    }
  };

  const handleVerifyOTP = async (e) => {
    setLoading(true);
    e.preventDefault();
    setLoginError("");

    const response = await verifyOTP();
    if (
      response?.data?.message == "Invalid OTP." ||
      response?.data?.message == "OTP is expired. Please re-generate OTP." ||
      response?.data?.message == "OTP is already used. Please re-generate OTP."
    ) {
      onFailure(response?.data?.message);
      setOtpValues(defaultOTPObj);
      setLoginError(response?.data?.message);
      setStep("enter otp");
    } else {
    onSuccess();
      onCancel();
    }
    setLoading(false);
  };

  const verifyOTP = async () => {
    const otpString = Object.values(otpValues).join("");
    try {
      const response = await http.post("/api/Auth/verify-otp", {
        email: userObj.userEmail,
        otp: otpString,
        password,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
      let timer;
      if (isResendDisabled && step == "enter otp" && counter > 0) {
        timer = setInterval(() => {
          setCounter((prev) => prev - 1);
        }, 1000);
      } else if (counter === 0) {
        setIsResendDisabled(false);
        clearInterval(timer);
      }
      return () => clearInterval(timer);
    }, [counter, isResendDisabled, step]);

  return (
    <div className="modal-overlay">
      <div className="approval-modal-content" style={{ height: "auto" }}>
        <span
          className="close"
          onClick={() => {
            onCancel();
          }}
        >
          &times;
        </span>
        <h6 className="modal-header p-2">Change Password</h6>{" "}
        {/* Modal Header */}
        <div className="modal-body p-3">
          {step === "change_password" && (
            <div className="d-flex flex-column justify-content-center">
              <p className="login-card-text text">Enter new password</p>
              <div className=" d-flex w-100 mt-3 flex-column align-items-center gap-2">
                <form className="w-100" onSubmit={handleResetPassword}>
                  <div className="col-sm-12 mb-3">
                    <div
                      className="form-floating"
                      // style={{ position: "relative" }}
                    >
                      <p className="logtext text-start">New password</p>
                      <input
                        className="form-controlinputbox ps-5 pe-5"
                        id="passwordInput"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => handlePassword(e.target.value)}
                        required
                      />
                      <img src={passlogo} className="input-icon" alt="logo" />
                      <i
                        className={`fa-solid mt-4 ${
                          showPassword ? "fa-eye-slash" : "fa-eye"
                        } fa-sm showAndHidePass`}
                        onClick={resetScreenShowPass}
                      ></i>
                    </div>
                    <div>
                      {strengthNew > 0 ? (
                        <progress
                          hidden={password.length === 0}
                          className={`password strength-${strengthNew}`}
                          value={strengthNew}
                          max="4"
                        />
                      ) : null}
                    </div>
                    <div
                      className={`feedback strength-${strengthNew}`}
                      hidden={password.length === 0}
                    >
                      {feedback}
                    </div>
                  </div>
                  <div className="col-sm-12 mb-3">
                    <div className="form-floating">
                      <p className="logtext text-start">Re-Enter Password</p>
                      <input
                        className="form-controlinputbox ps-5 pe-5"
                        id="floatingInput"
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <img src={passlogo} className="input-icon" alt="logo" />
                      <i
                        className={`fa-solid mt-4 ${
                          showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                        } fa-sm  showAndHidePass`}
                        onClick={confirmShowPassword}
                      ></i>
                    </div>
                  </div>
                  <>
                    {loginError ||
                      (true && <div className="text-danger">{loginError}</div>)}
                  </>
                  <div className="col-sm-12 mb-2 ">
                    <button
                      type="submit"
                      className="btn-primary mb-3 w-100"
                      disabled={enableCountniue}
                    >
                      {loading ? "Please Wait..." : "Continue"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
          {step === "confirm_email" && (
            <div className="d-flex flex-column justify-content-center">
              <p className="login-card-text text">
                Confirm if you want to proceed with resetting your password for the below email address.
              </p>
              <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
                <form className="w-100">
                  <div className="col-sm-12 mb-3">
                    <div className="form-floating">
                      <p className="logtext text-start">Email Address</p>
                      <input
                        type="email"
                        value={userObj?.userEmail}
                        className="form-controlinputbox  ps-5"
                        id="floatingInput"
                        disabled
                      />
                      <img src={emaillogo} className="input-icon" alt="logo" />
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <button
                      type="submit"
                      className="btn-primary mb-3 w-100"
                      onClick={() => {
                        setStep("change_password");
                        setOtpValues(defaultOTPObj);
                      }}
                    >
                      {loading ? "Please Wait..." : "Continue"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
          {step === "enter otp" && (
            <>
              <div className=" d-flex flex-column justify-content-center">
                <p className="login-card-text text">
                  Enter the 6-digit code sent to{" "}
                  <strong
                    style={{
                      // marginLeft: "5px",
                      color: "#000000",
                      fontSize: "14px",
                    }}
                  >
                    {userObj?.userEmail}
                  </strong>
                  . This OTP is valid for 10 minutes only.
                </p>
                <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
                  <form className="w-100">
                    <div className="col-sm-12 mb-3 d-flex gap-3 login-otp justify-content-center">
                      <input
                        type="text"
                        className="form-control-box1"
                        maxLength="1"
                        value={otpValues.digit1}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit1", 0);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                        ref={(el) => (inputRefs.current[0] = el)}
                        onPaste={handlePaste}
                      />
                      <input
                        type="text"
                        className="form-control-box2"
                        maxLength="1"
                        value={otpValues.digit2}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit2", 1);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 1)}
                        ref={(el) => (inputRefs.current[1] = el)}
                      />
                      <input
                        type="text"
                        className="form-control-box3"
                        maxLength="1"
                        value={otpValues.digit3}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit3", 2);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 2)}
                        ref={(el) => (inputRefs.current[2] = el)}
                      />
                      <input
                        type="text"
                        className="form-control-box4"
                        maxLength="1"
                        value={otpValues.digit4}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit4", 3);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 3)}
                        ref={(el) => (inputRefs.current[3] = el)}
                      />
                      <input
                        type="text"
                        className="form-control-box5"
                        maxLength="1"
                        value={otpValues.digit5}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit5", 4);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 4)}
                        ref={(el) => (inputRefs.current[4] = el)}
                      />
                      <input
                        type="text"
                        className="form-control-box6"
                        maxLength="1"
                        value={otpValues.digit6}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit6", 5);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 5)}
                        ref={(el) => (inputRefs.current[5] = el)}
                      />
                    </div>
                    <div className="col-sm-12 text-center">
                      <p
                      // style={{ width: "150px", marginLeft: "-20px !important" }}
                      >
                        <span
                          onClick={isResendDisabled ? null : handleResend}
                          className="resend"
                          style={{
                            cursor: isResendDisabled
                              ? "not-allowed"
                              : "pointer",
                          }}
                        >
                          {isResendDisabled
                            ? `OTP sent to your email. Resend OTP in ${counter}s`
                            : "Resend OTP"}
                        </span>
                      </p>
                      <button
                        type="submit"
                        className="btn-primary mb-3 w-100"
                        onClick={(e) => handleVerifyOTP(e)}
                        disabled={
                          loading ||
                          Object.values(otpValues).some((digit) => digit === "")
                        }
                      >
                        {loading ? "Please Wait..." : "Verify OTP"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
